
import param from '~/utils/url/param.js'
export default {
  name: 'social-email',
  props: {
    url: {
      type: String,
      async default() {
        return await window.location.href
      }
    },
    title: { type: String, default: '' },
    body: { type: String, default: '' }
  },
  methods: {
    open() {
      window.open(
        'mailto:' + param({ subject: this.title, body: this.body || this.url }),
        '__blank'
      )
    }
  }
}
